<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="col-sm-7">
          <div class="element-box mb-0">
            <h5 id="estadotitle" class="form-header">Estado de Cuenta de
              Proveedores <i class="fas fa-hand-holding-usd"></i>
            </h5>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <small v-if="current.errors && current.errors.cliente_nit" class="form-text text-danger">{{
                    current.errors.cliente_nit }}</small>
                  <label v-bind:class="{
                    'text-danger':
                      current.errors & current.errors.cliente_nit,
                  }"></label>
                  <ProveedoresSelectComponent :current="current"></ProveedoresSelectComponent>
                  <small v-if="current.errors && current.errors.proveedor" class="form-text text-danger">{{
                    current.errors.proveedor }}</small>
                </div>
              </div>
              <div class="col-sm-6">
                <label>Fecha Inicial</label>
                <div class="form-group">
                  <input type="date" class="form-control" v-model="current.fecha_inicial" />
                  <small v-if="current.errors && current.errors.fecha_inicial" class="form-text text-danger">{{
                    current.errors.fecha_inicial[0] }}</small>
                </div>
              </div>
              <div class="col-sm-6">
                <label>Fecha Final</label>
                <div class="form-group">
                  <input type="date" class="form-control" v-model="current.fecha_final" />
                  <small v-if="current.errors && current.errors.fecha_final" class="form-text text-danger">{{
                    current.errors.fecha_final }}</small>
                </div>
              </div>
            </div>
            <div class="row form-buttons-w">
              <button class="btn btn-md btn-warning" @click="refreshDataDefault">
                Limpiar Datos
                <i class="fas fa-history"></i>
              </button>
              <button @click="Imprimir()" class="btn btn-dark  btn-md">
                <span>Imprimir Estado de Cta.
                  <i class="fas fa-print"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";

export default {
  components: {
    ProveedoresSelectComponent,
  },
  data() {
    return {
      current: {
        fecha_final: null,
        proveedor: null,
        fecha_inicial: null,
        cliente_nit: "",
        solo_con_saldo: "",
        errors: {
          cliente_nit: "",
        },
      },
      datos: "",
    };
  },
  methods: {
    Imprimir() {
      let self = this;
      if (self.current.proveedor == null) {
        Notifications.alert.error("Proveedor", "Este campo es obligatorio");
        return;
      }
      if (self.current.fecha_inicial == null) {
        Notifications.alert.error("Fecha inicial", "Este campo es obligatorio");
        return;
      }
      if (self.current.fecha_final == null) {
        Notifications.alert.error("Fecha final", "Este campo es obligatorio");
        return;
      }
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_name=cxp/estado_cuenta/estado_cuenta_prov.jrxml&proveedor=${self.current.proveedor.codigo}&fechainicial=${self.current.fecha_inicial}&fechafinal=${self.current.fecha_final}`
      );
    },
    refreshDataDefault() {
      let self = this;
      self.current.proveedor = "";
      self.current.fecha_final = "";
      self.current.fecha_inicial = "";
    },
  },
};
</script>
<style>
#estadotitle {
  text-align: center;
}
</style>